import findIndex from "lodash/findIndex";

const getChapterNumber = (state, ownProps) => {
  const topLevelChapters = state.story.topLevelChapters;
  const chapterId = ownProps.chapterId;

  const index = findIndex(topLevelChapters, { id: chapterId });

  if (index > -1) {
    return index + 1;
  }

  return null;
};

export default getChapterNumber;
